import React from "react";
import { StyleSheet, View } from "react-native";
import SButton from "styled42/components/SButton";
import { Colors } from "styled42/config";
import Resend from "icons/Resend";
import ResendGray from "icons/ResendGray";
import SText from "styled42/components/SText";
import { pushClevertapEvent } from "utils/clevertapEvents";
import VernacManager from "utils/vernacular";
import { sendOTP } from "./utils";

class OTPResend extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      resendButtonEnabled: false,
      timer: 30
    };
    this.setTimeoutId = setTimeout(async () => {
      this.setState({ resendButtonEnabled: true });
    }, 29000);

    this.interval = setInterval(() => {
      return this.setState((prevState) => {
        return { timer: prevState.timer - 1 };
      });
    }, 1000);
  }

  componentDidUpdate() {
    if (this.state.timer === 1) {
      clearInterval(this.interval);
      this.setState({ timer: 30 });
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  resendOtp = async () => {
    const {
      state: { variant },
      onClick
    } = this.props;

    // callback to clear the text inputs
    if (onClick) onClick();

    pushClevertapEvent("loginRegister Clicks", {
      Current_Page: "New loginRegistration",
      Page_Modal: "OTP Verification",
      Test_Case: variant,
      Type: "Resend OTP"
    });
    this.setState({
      resendButtonEnabled: false
    });

    this.setTimeoutId = setTimeout(async () => {
      this.setState({ resendButtonEnabled: true });
    }, 29000);

    this.interval = setInterval(() => {
      return this.setState((prevState) => {
        return { timer: prevState.timer - 1 };
      });
    }, 1000);

    const { client, state, onSMSReceived, setError } = this.props;
    await sendOTP({
      client,
      state,
      onSMSReceived,
      setError
    });
  };

  render() {
    const { resendButtonEnabled, timer } = this.state;
    return (
      <View style={{ display: "flex", flex: 1, flexDirection: "column" }}>
        <SButton
          disabled={!resendButtonEnabled}
          prefixIcon={resendButtonEnabled ? Resend : ResendGray}
          text={VernacManager.translateString("new_onboarding_resend_otp")}
          type="text"
          textProps={{
            size: 12,
            color: resendButtonEnabled ? Colors.Orange[5] : Colors.Grey[13]
          }}
          containerStyle={styles.resendCTA}
          onClick={this.resendOtp}
        />
        {!resendButtonEnabled && (
          <SText style={styles.timer}>{timer} secs</SText>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  resendCTA: {
    marginTop: 5,
    alignSelf: "center"
  },
  timer: {
    marginLeft: 5,
    marginTop: 5,
    marginRight: 4,
    color: Colors.Grey[8],
    fontSize: 12,
    width: "100%",
    textAlign: "center"
  }
});

export default OTPResend;
